import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "iconButton"
};
const _hoisted_2 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_icon_button = _resolveComponent("icon-button");
  const _component_confirm_dialog = _resolveComponent("confirm-dialog");
  return _openBlock(), _createElementBlock(_Fragment, null, [_ctx.displayAsIcon ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_icon_button, {
    class: "buttonNavigation",
    icon: "restart",
    color: "light2",
    disabled: _ctx.disabled,
    tooltip: _ctx.$t('myAccount.speachSteering.popUpQuizz.reset'),
    onClick: _ctx.resetQuiz
  }, null, 8, ["disabled", "tooltip", "onClick"])])) : (_openBlock(), _createElementBlock("a", {
    key: 1,
    disabled: _ctx.disabled,
    onClick: _cache[0] || (_cache[0] = $event => _ctx.isConfirmModalVisible = true)
  }, _toDisplayString(_ctx.$t('myAccount.speachSteering.popUpQuizz.reset')), 9, _hoisted_2)), _createVNode(_component_confirm_dialog, {
    visible: _ctx.isConfirmModalVisible,
    title: _ctx.$t('myAccount.speachSteering.popUpQuizz.reset'),
    message: _ctx.$t('myAccount.speachSteering.popUpQuizz.confirmation'),
    onOnConfirmed: _ctx.resetQuiz,
    onOnDialogClose: _cache[1] || (_cache[1] = $event => _ctx.isConfirmModalVisible = false),
    onOnCanceled: _cache[2] || (_cache[2] = $event => _ctx.isConfirmModalVisible = false)
  }, null, 8, ["visible", "title", "message", "onOnConfirmed"])], 64);
}